// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CreateSocialItem-cls1___40891d182b11d3f8ec5{/*!*/}.CreateSocialItem-cls2___e6329e63cbf539d5fc8{display:flex;flex-direction:column;grid-gap:16px;gap:16px;overflow-y:hidden;padding:16px;width:100%;height:100%;max-width:100%;max-height:100%}@media(min-width: 768px){.CreateSocialItem-cls2___e6329e63cbf539d5fc8{padding:32px;width:60vw;height:auto}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CreateSocialItem-cls1___40891d182b11d3f8ec5",
	"cls2": "CreateSocialItem-cls2___e6329e63cbf539d5fc8 CreateSocialItem-cls1___40891d182b11d3f8ec5"
};
export default ___CSS_LOADER_EXPORT___;
